import store from '../store/store'

const errors = {
  empty: 'Поле не может быть пустым',
  emptyAll: 'Все поля должны быть заполнены',
  emptyAllCorrect: 'Все поля должны быть заполнены корректно',
  notEqualPassword: 'Пароли не совпадают',
  lessThanZero: 'Не может быть меньше нуля',
  moreThanHundred: 'Не может быть больше ста',
  selectValueFromDropdown: 'Выберите значение из выпадающего списка',
  mustBeBetweenOneAnd31: 'Значение должно быть между 1 и 31',
  mustBeBetween0And31: 'Значение должно быть между 0 и 31',
  'unknown error': 'Неизвестная ошибка',
  'incorrect login or password': 'Неверный логин или пароль',
  'already exists': 'Уже есть в БД',
  'only update': 'Возможно только обновление',
  'incorrect: passwordCurrent': 'Неверный текущий пароль',
  'Пользователь не найден': 'Пользователь не найден',
  'Некорректный email': 'Указан некорректный адрес эл.почты',
  'File too large': 'Вы пытаетесь загрузить слишком большой файл'
}

const statuses = {
  401: {
    message: 'Авторизуйтесь заново',
    action: function () {
      store.commit('auth/setErrMain', 'Авторизуйтесь заново')
      store.dispatch('auth/signOut')
    }
  }
}

function getStatusStr (status) {
  if (!status) return null
  if (statuses[status]) statuses[status].action()
  return statuses[status]
};

function getErrorStr (message) {
  if (!message) return errors['unknown error']
  let errorStr = errors[message]
  if (!errorStr) return errors['unknown error']
  return errorStr
};

export default { errors, getErrorStr, getStatusStr }
